// ref: https://github.com/jusbrasil/finder/blob/e54b649114e41dea78765c4014f746dda199b940/src/utils/haystack-filters/enums/journal-types.json
export const journalTypes = [
  { label: 'Todos', value: '' },
  { label: 'Executivo', value: 'executivo' },
  { label: 'Judiciário', value: 'judiciario' },
  { label: 'Legislativo', value: 'legislativo' },
  { label: 'Ministério Público', value: 'ministerio_publico' },
]
